
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.256 14.422L13 6.678 9.322 3l-7.744 7.744a.836.836 0 00-.22.387L.5 15.5l4.368-.858a.835.835 0 00.388-.22zM15.5 4.178c.65-.65.65-1.705 0-2.356L14.178.5a1.666 1.666 0 00-2.356 0L10.5 1.822 14.178 5.5 15.5 4.178z","fill":"#7E8186"}})])
          )
        }
      }
    